import { publicImageProps } from "../../../../services/config";
import { digitsThree } from "../../../../utils/price";

function SingleOrderCard({ data }) {
  return (
    <div className="flex flex-col lg:flex-row items-center py-6 border-b border-gray-200 gap-6 w-full">
      <div className="img-box max-lg:w-full">
        <img
          {...publicImageProps(data.product?.mainImage, { variant: "medium_" })}
          className="aspect-square w-full lg:max-w-[140px] rounded-xl"
        />
      </div>
      <div className="flex flex-row items-center w-full ">
        <div className="grid grid-cols-1 lg:grid-cols-2 w-full">
          <div className="flex items-center">
            <div className="">
              <h2 className="font-semibold text-xl leading-8 text-black mb-3">
                {data?.productName}
              </h2>
              <p className="font-normal text-sm leading-8 text-gray-500 mb-3 ">
                قیمت : {digitsThree(data?.basePrice)}
              </p>
            </div>
          </div>
          <div className="flex justify-between px-4">
            <div className="col-span-5 lg:col-span-2 flex items-center max-lg:mt-3">
              <div className="flex gap-3 lg:block">
                <p className="font-medium text-md whitespace-nowrap leading-6 text-black">
                  تعداد
                </p>
                <p className="font-medium text-md leading-6 py-0.5 px-3 whitespace-nowrap rounded-full lg:mt-3 bg-indigo-50 text-indigo-600">
                  {digitsThree(data?.count)}
                </p>
              </div>
            </div>
            <div className="col-span-5 lg:col-span-2 flex items-center max-lg:mt-3">
              <div className="flex gap-3 lg:block">
                <p className="font-medium text-md whitespace-nowrap leading-6 text-black">
                  تخفیف
                </p>
                <p className="font-medium text-md whitespace-nowrap leading-7 lg:mt-3 text-emerald-500">
                  {digitsThree(data?.discountPrice)}
                </p>
              </div>
            </div>

            <div className="col-span-5 lg:col-span-2 flex items-center max-lg:mt-3">
              <div className="flex gap-3 lg:block">
                <p className="font-medium text-md whitespace-nowrap leading-6 text-black">
                  قیمت نهایی
                </p>
                <p className="lg:mt-4 font-medium text-md leading-7 text-indigo-600">
                  {digitsThree(data?.finalPrice)}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SingleOrderCard;
